
import { useState } from 'react';

export default function ChatWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [showFAQ, setShowFAQ] = useState(false);
  const [messages, setMessages] = useState([
    {
      type: 'bot',
      text: "Hello! I'm your Thyamis assistant. How can I help you today?",
    },
  ]);
  const [inputValue, setInputValue] = useState('');

  const handleSendMessage = () => {
    if (inputValue.trim()) {
      setMessages([...messages, { type: 'user', text: inputValue }]);
      setInputValue('');
      setTimeout(() => {
        setMessages((prev) => [
          ...prev,
          {
            type: 'bot',
            text: 'Thank you for your message. Our team will get back to you shortly. For immediate assistance, please call us at +31 (0)616300011.',
          },
        ]);
      }, 1000);
    }
  };

  const handleQuickAction = (action: string) => {
    switch (action) {
      case 'quote':
        (window as any).showPartnerForm?.();
        break;
      case 'faq':
        setShowFAQ(true);
        break;
      default:
        setMessages([
          ...messages,
          {
            type: 'bot',
            text: 'Thank you for your interest. Our team will assist you shortly. You can also call us at +31 (0)6 1074 9083.',
          },
        ]);
    }
  };

  const handleFAQClick = (question: string, answer: string) => {
    setShowFAQ(false);
    setMessages([
      ...messages,
      { type: 'user', text: question },
      { type: 'bot', text: answer },
    ]);
  };

  const faqs = [
    {
      question: 'What services does Thyamis offer?',
      answer:
        'Thyamis offers comprehensive IT solutions including hardware, software licensing, cloud services, cybersecurity, AI implementation, and managed IT services for businesses of all sizes.',
    },
    {
      question: 'How can I get a quote?',
      answer:
        'You can request a quote by filling out our contact form, calling us at +31 (0)6 1074 9083, or clicking the "Request Quote" button on any product page.',
    },
    {
      question: 'Do you provide technical support?',
      answer:
        'Yes, we provide comprehensive technical support including 24/7 monitoring, helpdesk services, and on-site support for our managed service clients.',
    },
    {
      question: 'What industries do you serve?',
      answer:
        'We serve various industries including technology, finance, healthcare, manufacturing, retail, education, and more. Our solutions are tailored to meet specific industry requirements.',
    },
    {
      question: 'Do you offer AI consulting services?',
      answer:
        'Yes, we offer comprehensive AI consulting services including readiness assessments, custom AI development, machine learning implementation, and AI integration services.',
    },
  ];

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-primary text-white w-14 h-14 rounded-full shadow-lg flex items-center justify-center hover:bg-primary/90 transition-all cursor-pointer"
      >
        <div className="w-7 h-7 flex items-center justify-center">
          {isOpen ? <i className="ri-close-line text-2xl"></i> : <i className="ri-chat-3-line text-2xl"></i>}
        </div>
      </button>

      {isOpen && (
        <div className="absolute bottom-20 right-0 w-96 h-[500px] bg-white rounded-lg shadow-2xl border border-gray-200 flex flex-col">
          <div
            className="text-white p-4 rounded-t-lg flex items-center justify-between"
            style={{ background: 'linear-gradient(135deg, #0066CC 0%, #0052A3 100%)' }}
          >
            <div className="flex items-center">
              <div className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center mr-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-customer-service-2-line"></i>
                </div>
              </div>
              <div>
                <h3 className="font-semibold">Customer Service</h3>
                <div className="flex items-center text-xs opacity-90">
                  <div className="w-2 h-2 bg-green-400 rounded-full mr-1"></div>
                  <span>Online</span>
                </div>
              </div>
            </div>
          </div>

          {!showFAQ && (
            <>
              <div className="p-3 border-b border-gray-100">
                <div className="grid grid-cols-2 gap-2">
                  <button
                    onClick={() => handleQuickAction('quote')}
                    className="bg-blue-50 text-primary p-2 rounded text-xs font-medium hover:bg-blue-100 transition-colors cursor-pointer"
                  >
                    <div className="w-4 h-4 flex items-center justify-center mx-auto mb-1">
                      <i className="ri-file-list-line"></i>
                    </div>
                    <span>Get Quote</span>
                  </button>
                  <button
                    onClick={() => handleQuickAction('support')}
                    className="bg-green-50 text-green-600 p-2 rounded text-xs font-medium hover:bg-green-100 transition-colors cursor-pointer"
                  >
                    <div className="w-4 h-4 flex items-center justify-center mx-auto mb-1">
                      <i className="ri-customer-service-line"></i>
                    </div>
                    <span>Tech Support</span>
                  </button>
                  <button
                    onClick={() => handleQuickAction('products')}
                    className="bg-purple-50 text-purple-600 p-2 rounded text-xs font-medium hover:bg-purple-100 transition-colors cursor-pointer"
                  >
                    <div className="w-4 h-4 flex items-center justify-center mx-auto mb-1">
                      <i className="ri-shopping-bag-line"></i>
                    </div>
                    <span>Products</span>
                  </button>
                  <button
                    onClick={() => handleQuickAction('faq')}
                    className="bg-orange-50 text-orange-600 p-2 rounded text-xs font-medium hover:bg-orange-100 transition-colors cursor-pointer"
                  >
                    <div className="w-4 h-4 flex items-center justify-center mx-auto mb-1">
                      <i className="ri-question-line"></i>
                    </div>
                    <span>FAQ</span>
                  </button>
                </div>
              </div>

              <div className="flex-1 p-4 overflow-y-auto space-y-3">
                {messages.map((message, index) => (
                  <div key={index} className={`flex ${message.type === 'user' ? 'justify-end' : 'items-start'}`}>
                    {message.type === 'bot' && (
                      <div className="w-7 h-7 bg-primary bg-opacity-10 rounded-full flex items-center justify-center mr-2 flex-shrink-0">
                        <div className="w-4 h-4 flex items-center justify-center text-primary">
                          <i className="ri-robot-line"></i>
                        </div>
                      </div>
                    )}
                    <div
                      className={`rounded-lg p-3 max-w-[80%] ${
                        message.type === 'user' ? 'bg-primary text-white' : 'bg-gray-100 text-gray-800'
                      }`}
                    >
                      <p className="text-sm">{message.text}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="p-3 border-t border-gray-100">
                <div className="flex items-center space-x-2">
                  <input
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
                    placeholder="Type your message..."
                    className="flex-1 text-sm border border-gray-300 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
                  />
                  <button
                    onClick={handleSendMessage}
                    className="bg-primary text-white p-2 rounded-full hover:bg-primary/90 transition-colors cursor-pointer"
                  >
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-send-plane-fill"></i>
                    </div>
                  </button>
                </div>
              </div>
            </>
          )}

          {showFAQ && (
            <div className="flex-1 p-4 overflow-y-auto">
              <div className="space-y-3">
                <div className="text-sm font-semibold text-gray-700 mb-4">Frequently Asked Questions</div>
                <div className="space-y-2">
                  {faqs.map((faq, index) => (
                    <button
                      key={index}
                      onClick={() => handleFAQClick(faq.question, faq.answer)}
                      className="w-full text-left p-3 bg-gray-50 hover:bg-gray-100 rounded text-xs text-gray-700 transition-colors cursor-pointer"
                    >
                      {faq.question}
                    </button>
                  ))}
                </div>
                <button
                  onClick={() => setShowFAQ(false)}
                  className="w-full mt-4 text-primary text-xs font-medium py-2 border border-primary rounded hover:bg-primary hover:text-white transition-colors cursor-pointer"
                >
                  Back to Chat
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
